import dayjs from 'dayjs';

interface Column {
  id: 'title' | 'machine' | 'quantity' | 'colors' | 'chemicals' | 'createdAt';
  label: string;
  width?: number;
  align?: 'right' | 'left' | 'center';
  format?: (value: any) => React.ReactNode;
}

export const formattedLabel = {
  oxy: 'Oxy',
  soda: 'Soda',
  salt: 'Muối',
  javen: 'Zaven',
  sut: 'Sút',
};

export const columns: Column[] = [
  { id: 'title', label: 'Khách hàng - Tên màu', align: 'left', width: 200 },
  {
    id: 'machine',
    label: 'Máy',
    align: 'left',
    width: 100,
  },
  {
    id: 'quantity',
    label: 'Khối lượng (Kg)',
    align: 'left',
    width: 100,
  },
  {
    id: 'colors',
    label: 'Màu sử dụng (G)',
    align: 'left',
    width: 200,
    format: (value) =>
      Object.entries(value)
        .map(([name, quantity]) => `${formattedLabel[name as keyof typeof formattedLabel] || name}: ${quantity}`)
        .join('\n'),
  },
  {
    id: 'chemicals',
    label: 'Chất hóa học (Kg)',
    align: 'left',
    width: 200,
    format: (value) =>
      Object.entries(value)
        .map(([name, quantity]) => `${formattedLabel[name as keyof typeof formattedLabel] || name}: ${quantity}`)
        .join('\n'),
  },
  {
    id: 'createdAt',
    label: 'Thời gian',
    align: 'left',
    width: 100,
    format: (value) => dayjs(value).format('HH:mm DD/MM/YYYY'),
  },
];
